export const isChannelUnavailableError = error => {
  const errors = (Array.isArray(error?.errors) ? error.errors : [error]).filter(
    Boolean
  )

  return errors.some(entry => {
    const { extensions = {} } = entry || {}
    return (
      extensions.code === 'NOT_FOUND' &&
      extensions.reason === 'CHANNEL_UNAVAILABLE' &&
      (!extensions.action || extensions.action === 'SELECT_CHANNEL')
    )
  })
}
